import { render } from "./Recipes.vue?vue&type=template&id=d193019c&scoped=true"
import script from "./Recipes.vue?vue&type=script&lang=js"
export * from "./Recipes.vue?vue&type=script&lang=js"

import "./Recipes.vue?vue&type=style&index=0&id=d193019c&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-d193019c"

export default script